import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { WorkshopContext } from "../../contexts/workshop.context";
import Popup from "./popup";
import ParticipantsList from "./participantsList";

import { SpeakerOrderIcon } from "../../assets/icons";
import { defaultPlatforms } from "../../util/workshop.util";

const SpeakingOrder = ({ participants: rawParticipants, filterOnlineParticipants = false }) => {
  const { t } = useTranslation();

  const [participants, setParticipants] = useState([]);

  const { connectedUsers } = useContext(WorkshopContext);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (filterOnlineParticipants) {
      setParticipants(
        rawParticipants.filter((participant) =>
          connectedUsers.some(
            (user) => user.id === participant.id
          )
        )
      );
    } else {
      setParticipants(rawParticipants);
    }
  }, [rawParticipants, filterOnlineParticipants, connectedUsers]);

  const { workshopDetails: { platform } = {} } = useContext(WorkshopContext);

  return (
    <>
      {platform !== defaultPlatforms.mtOnline && platform !== defaultPlatforms.mtOnlineDemo && (
        <div
          className="mt-6 rounded-lg p-4 border-[1px] border-gray-100 flex flex-row gap-3 items-center justify-start cursor-pointer"
          onClick={() => setOpen(!open)}>
          <span className="w-8 h-8">
            <SpeakerOrderIcon />
          </span>
          <span
            className="text-lg font-normal text-gray-100"
            dangerouslySetInnerHTML={{ __html: t("speakingOrder") }}
          />
        </div>
      )}

      {(platform === defaultPlatforms.mtOnline || platform === defaultPlatforms.mtOnlineDemo) && (
        <button
          className="mt-6 rounded-full p-4 text-white-100 border-2 border-white-100"
          dangerouslySetInnerHTML={{ __html: t("speakingOrder") }}
          onClick={() => setOpen(!open)}
        />
      )}

      <Popup open={open} setOpen={setOpen}>
        <ParticipantsList heading={t("mtTaskOrder.heading")} participants={participants} />
      </Popup>
    </>
  );
};

export default SpeakingOrder;
